import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './FilterMobile.module.scss';

import Checkbox from '../Checkbox';
import CollapseVacancy from '../CollapseVacancy/CollapseVacancy';

import Button from '../Button';

const FilterMobile = ({
  openFilter,
  sections,
  apply,
  reset,
  inputCallback,
  currentQueries,
  setOpenFilter,
  count,
}) => {
  useEffect(() => {
    if (openFilter) {
      const y = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${y}px`;
      document.body.style.overflow = 'hidden';
    } else {
      const scrollY = parseInt(document.body.style.top || '0', 10) * -1;
      document.body.style = '';
      window.scrollTo(0, scrollY);
    }
  }, [openFilter]);

  return (
    <>
      <Button
        className={styles.mobileFilterBtn}
        size="small"
        count={count}
        onClick={() => setOpenFilter(true)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="14"
          viewBox="0 0 16 14"
          fill="none"
        >
          <path
            d="M15.4666 9.69232H4.79993C4.50538 9.69232 4.2666 9.9334 4.2666 10.2308C4.2666 10.5282 4.50538 10.7692 4.79993 10.7692H15.4666C15.7612 10.7692 15.9999 10.5282 15.9999 10.2308C15.9999 9.9334 15.7612 9.69232 15.4666 9.69232Z"
            fill="white"
          />
          <path
            d="M2.66678 12.3846C3.84499 12.3846 4.80011 11.4203 4.80011 10.2308C4.80011 9.04124 3.84499 8.07693 2.66678 8.07693C1.48857 8.07693 0.533447 9.04124 0.533447 10.2308C0.533447 11.4203 1.48857 12.3846 2.66678 12.3846Z"
            stroke="white"
          />
          <path
            d="M0.533398 3.23077H11.2001C11.4946 3.23077 11.7334 3.47185 11.7334 3.76924C11.7334 4.06662 11.4946 4.3077 11.2001 4.3077H0.533398C0.238846 4.3077 6.48499e-05 4.06662 6.48499e-05 3.76924C6.48499e-05 3.47185 0.238846 3.23077 0.533398 3.23077Z"
            fill="white"
          />
          <path
            d="M13.3332 5.92308C12.155 5.92308 11.1999 4.95877 11.1999 3.76923C11.1999 2.5797 12.155 1.61539 13.3332 1.61539C14.5114 1.61539 15.4666 2.5797 15.4666 3.76923C15.4666 4.95877 14.5114 5.92308 13.3332 5.92308Z"
            stroke="white"
          />
        </svg>
      </Button>
      {openFilter &&
        createPortal(
          <div className={styles.overlay}>
            <div className={styles.modal}>
              <div className={styles.header}>
                <div className={styles.headerTitle}>Фильтры</div>

                <button
                  className={styles.closeBtn}
                  onClick={() => setOpenFilter(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                    fill="none"
                  >
                    <path d="M9 9L23 23" stroke="black" strokeWidth="2" />
                    <path d="M9 23L23 9" stroke="black" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              <div className={styles.content}>
                {sections.map(({ key, title, items }) => (
                  <div key={key} className={styles.section}>
                    {title && (
                      <div className={styles.sectionTitle}>{title}</div>
                    )}

                    <CollapseVacancy
                      filterType={key}
                      size="small"
                      count={4}
                      toggler="Показать все"
                      data={items.map((item) => (
                        <div className={styles.checkbox} key={item.id}>
                          <Checkbox
                            section={key}
                            id={item.id}
                            value={item.name}
                            type={key === 'experience' ? 'radio' : null}
                            inputCallback={inputCallback}
                            checkedStatus={
                              currentQueries?.[key]?.includes(item.id) || false
                            }
                          />
                        </div>
                      ))}
                    />
                  </div>
                ))}
              </div>

              <div className={styles.footer}>
                <Button onClick={apply} design="green">
                  Применить
                </Button>
                <Button onClick={reset} design="green-outline">
                  Сбросить
                </Button>
              </div>
            </div>
          </div>,
          document.getElementById('filter-portal')
        )}
    </>
  );
};

export default FilterMobile;
